/* Delegate disclosures so cart section replacements need no reinitialisation. */
(() => {
  const animations = new WeakMap();
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.cc-cart-bundle > summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details.animate) return;
    event.preventDefault();

    const expanding = !details.open || details.hasAttribute('data-closing');
    const startHeight = details.getBoundingClientRect().height;
    const previous = animations.get(details);
    if (previous) {
      previous.onfinish = null;
      previous.cancel();
    }
    const finish = () => {
      details.open = expanding;
      details.removeAttribute('data-closing');
      details.style.removeProperty('overflow');
      animations.delete(details);
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }

    details.open = true;
    details.toggleAttribute('data-closing', !expanding);
    details.style.overflow = 'hidden';
    const endHeight = expanding ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
    const animation = details.animate(
      {height: [`${startHeight}px`, `${endHeight}px`]},
      {duration: 240, easing: 'ease-in-out'}
    );
    animations.set(details, animation);
    animation.onfinish = finish;
  });
})();

/* Recommendations are fetched only when the drawer opens. Shopify supplies
   market prices and access-filtered markup; the cart remains usable on failure. */
if (!customElements.get('cc-cart-recommendations')) {
  const cache = new Map();
  customElements.define('cc-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.ccServerMarkup = this.outerHTML;
      this.controller = new AbortController();
      this.list = this.querySelector('[data-cc-recommendation-list]');
      this.seen = new Set();
      this.list.querySelectorAll('[data-cc-recommendation]').forEach(card => {
        if (this.seen.has(card.dataset.ccRecommendation) || this.seen.size >= 3) card.remove();
        else this.seen.add(card.dataset.ccRecommendation);
      });
      this.hidden = this.seen.size === 0;
      document.addEventListener('theme:cart:open', () => this.load(), {signal: this.controller.signal});
      if (document.body.classList.contains('js-drawer-open-cart')) this.load();
    }
    disconnectedCallback() { this.controller.abort(); }
    append(root) {
      root.querySelectorAll('[data-cc-recommendation]').forEach(card => {
        if (this.seen.size >= 3 || this.seen.has(card.dataset.ccRecommendation)) return;
        this.seen.add(card.dataset.ccRecommendation);
        this.list.append(card.cloneNode(true));
      });
      this.hidden = this.seen.size === 0;
    }
    async load() {
      if (this.loaded || window.isWsgCustomer) return;
      this.loaded = true;
      try {
        if (this.dataset.productId && this.seen.size < 3) {
          for (const intent of ['complementary', 'related']) {
            if (this.seen.size >= 3) break;
            const url = new URL(this.dataset.url, location.origin);
            url.search = new URLSearchParams({product_id: this.dataset.productId, section_id: 'api-cart-recommendations', limit: '8', intent});
            const key = `${url}|${this.dataset.excluded}|${this.dataset.market}`;
            let markup = cache.get(key);
            if (!markup) {
              const timeout = setTimeout(() => this.requestController.abort(), 5000);
              this.requestController = new AbortController();
              const disconnect = () => this.requestController.abort();
              this.controller.signal.addEventListener('abort', disconnect, {once: true});
              try {
                const response = await fetch(url, {signal: this.requestController.signal});
                if (!response.ok) continue;
                markup = await response.text();
                if (cache.size >= 12) cache.delete(cache.keys().next().value);
                cache.set(key, markup);
              } finally {
                clearTimeout(timeout);
                this.controller.signal.removeEventListener('abort', disconnect);
              }
            }
            const html = new DOMParser().parseFromString(markup, 'text/html');
            const result = html.querySelector('[data-cc-recommendation-response]');
            if (result) this.append(result);
          }
        }
      } catch (error) {
        if (this.controller.signal.aborted) return;
      }
      if (this.isConnected) this.append(this.querySelector('template').content);
    }
  });
}
